var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ProfessionPageSectionCityTabs"},[_c('BlockHeading',{attrs:{"title-level":2,"title":_vm.$t('professionalsPage.cities.title', {
        thePerson: _vm.profession.theperson.toLowerCase(),
      })}}),_c('CityTabs',{attrs:{"profession":_vm.profession,"city-person-count":_vm.cities}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }